// extracted by mini-css-extract-plugin
export default {"wrapper":"simple-table_wrapper__piFuy","footer":"simple-table_footer__uPRMO","loader":"simple-table_loader__fffZL"};